import { formatDate } from '@angular/common';
import { ChangeDetectionStrategy, HostListener, Component, Inject, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FinancRp } from '../../../../../shared/interfaces/financ-rp';
import { FinancRpService } from '../../../../../shared/services/financ-rp.service';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';

import * as moment from 'moment';
import { Portador } from '../../../../../shared/interfaces/portador';
import { TipoCobranca } from '../../../../../shared/interfaces/tipo-cobranca';
import { PortadorService } from '../../../../../shared/services/portador.service';
import { TipoCobrancaService } from '../../../../../shared/services/tipo-cobranca.service';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, tap, switchMap, finalize, filter, takeUntil, delay, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FinancRpPopupComponent } from '../../../../../../app/views/movimentacao/financeiro/financ-rp/financ-rp-popup/financ-rp-popup.component';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-lancamento-parcelas',
  templateUrl: 'lancamento-parcelas.component.html',
  styleUrls: ['lancamento-parcelas.component.scss'],
})
export class LancamentoParcelasComponent implements OnInit, OnDestroy {

  @ViewChild('ngxDatatable') ngxDatatable: DatatableComponent;
  
  protected _onDestroy = new Subject<void>();

  public doctoCForm: FormGroup;
  lcto: FatDoctoC;
  
  isEditableParcela = {};
  parcelas: FinancRp[] = new Array;

  portadores: Portador[];
  
  filteredTipoCobrancas: ReplaySubject<TipoCobranca[]> = new ReplaySubject<TipoCobranca[]>(1);
  tipoCobrancas: TipoCobranca[];
  searching: boolean;
  condPgP: any;
  itemForm: any;
  saveParcelas = false;

  // @HostListener('window:keyup.esc') onKeyUp() {
  //   if (this.dialog.openDialogs.length > 0) {
  //     console.log('@HostListener(window:keyup.esc) onKeyUp()');
  //     this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
  //       .subscribe(res => {
  //         if (res) {
  //           this.dialogRef.close();
  //         }
  //       });
  //   }
  // }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoParcelasComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private portadorService: PortadorService,
    private tipoCobrancaService: TipoCobrancaService,
    private confirmService: AppConfirmService,
    // private cadastroFinancRpService: FinancRpService,
    private fatDoctoCService: FatDoctoCService,
    private loader: AppLoaderService,
    private financRpService: FinancRpService,
    private layout: LayoutService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    console.log('INIT Parc');
    this.doctoCForm = this.data.payload;
    this.lcto = this.doctoCForm.value;

    console.log(`Contem baixa : ${this.lcto.contemBaixa}`);


    this.portadorService.getPortadorPage(1,100).subscribe(val=>this.portadores = val.content);
    this.tipoCobrancaService.getTipoCobrancaPage(1,100).subscribe(val=>{
      this.tipoCobrancas = val.content;
      this.filteredTipoCobrancas.next( val.content);
    });
    this.fatDoctoCService.getFinancParcelas(this.lcto?.controle).subscribe(parcelas => {
      this.parcelas = parcelas.sort((a,b)=>(a.parcela??0) - (b?.parcela??0));
      this.reloadParcelaItens();
    })
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
    // Aguarda a renderização completa do diálogo
    setTimeout(() => {
      if (this.ngxDatatable) {
        this.ngxDatatable.recalculate();
        this.ngxDatatable.recalculateColumns();
        // Força um segundo recálculo após um pequeno delay para garantir que o layout esteja estabilizado
        setTimeout(() => {
          this.ngxDatatable.recalculate();
        }, 100);
      }
    }, 0);

    // Observador de redimensionamento para ajustar colunas dinamicamente
    this.dialogRef.afterOpened().subscribe(() => {
      const resizeObserver = new ResizeObserver(() => {
        if (this.ngxDatatable) {
          this.ngxDatatable.recalculate();
          this.ngxDatatable.recalculateColumns();
        }
      });
      resizeObserver.observe(document.querySelector('.mat-dialog-container') as Element);
      this._onDestroy.subscribe(() => resizeObserver.disconnect());
    });
  }

  //save parcela
  saveParcela(rowIndex: string, row: any) {
    this.saveParcelas = true;
    this.isEditableParcela[rowIndex] = !this.isEditableParcela[rowIndex];
    this.fatDoctoCService.saveOrUpdateAndRecalcFinancParcelas(row.value)
      .subscribe(res => {
        this.reloadParcelas(res);
      }, error=>{
        this.saveParcelas = false;
        this.confirmService.confirm(
         {
           message: `A T E N Ç Ã O !  ERRO Salvando a parcela ${row.value.parcela}  ... ${JSON.stringify(error.error)}`,
           error: true
         });
     });
  }

  private reloadParcelas(res: FinancRp[]) {
    this.parcelas = res.sort((a, b) => (a.parcela ?? 0) - (b?.parcela ?? 0));
    console.log(`salvo parcelas ${JSON.stringify(res)}`);
    this.reloadParcelaItens();
    this.saveParcelas = false;
  }

  changeDias(row: FormGroup) {
    row.controls['vcto'].setValue(moment(row.controls['emissao'].value).add(row.controls['dias'].value, 'days'));
    moment(row.controls['vcto'].value).format("dd/MM/yyyy");

    console.log(`calculo ${moment(row.controls['emissao'].value).add(row.controls['dias'].value, 'days')}`);
    console.log(`dias:  ${row.controls['dias'].value}`);
    console.log(`vcto:  ${row.controls['vcto'].value}`);
    this.saveParcelas = true;
    this.fatDoctoCService.saveOrUpdateAndRecalcFinancParcelas(row.value)
    .subscribe(res => {
      this.reloadParcelas(res);
    }, error=>{
      console.log(error);
      
       this.saveParcelas = false;
       this.confirmService.confirm(
        {
          message: `A T E N Ç Ã O !  ERRO Salvando a parcela ${row.value.parcela}  ... ${JSON.stringify(error.error)}`,
          error: true
        });
    });
    this.isEditableParcela = {};

  }

  changeVcto(row: FormGroup) {
    row.controls['dias'].setValue(moment(row.controls['vcto'].value).diff(row.controls['emissao'].value, 'days'));
    this.fatDoctoCService.saveOrUpdateAndRecalcFinancParcelas(row.value)
    .subscribe(res => {
      this.reloadParcelas(res);
    }, error=>{
      this.saveParcelas = false;
      this.confirmService.confirm(
       {
         message: `A T E N Ç Ã O !  ERRO Salvando a parcela ${row.value.parcela}  ... ${JSON.stringify(error.error)}`,
         error: true
       });
   });
    this.isEditableParcela = {};
  }

  reloadParcelaItens() {
    this.doctoCForm.setControl('financRps', this.fb.array([]));
    this.parcelas?.forEach(parcela => {
      this.addParcela(parcela);
    });
    this.doctoCForm.setControl('financRps', this.parcelasFormArray);
  }

  addParcela(rp: FinancRp) {
    this.parcelasFormArray.push(
      this.newFbGroup(rp)
    );
  }

  private newFbGroup(rp: FinancRp) {
    const fbGroup = this.fb.group({
      id: [rp.id],
      codigo: [rp.codigo],
      cadastro: [rp.cadastro],
      carencia: [rp.carencia],
      dataref: [rp.dataref],
      descAte: [rp.descAte],
      descValor: [rp.descValor],
      desconto: [rp.desconto],
      docto: [rp.docto],
      emissao: [rp.emissao],
      dias: [rp.dias],
      vcto: [rp.vcto],
      fatura: [rp.fatura],
      moedaId: [rp.moedaId],
      natureza: [rp.natureza],
      nossonumero: [rp.nossonumero],
      numeroboleto: [rp.numeroboleto],
      parcela: [rp.parcela],
      perAcrescimo: [rp.perAcrescimo],
      perJurosmora: [rp.perJurosmora],
      perMulta: [rp.perMulta],
      prorrogacao: [rp.prorrogacao],
      statusReg: [rp.statusReg],
      valorAcrescimo: [rp.valorAcrescimo],
      valorDesconto: [rp.valorDesconto],
      valorJurosmora: [rp.valorJurosmora],
      valorSaldo: [rp.valorSaldo],
      valorTotal: [rp.valorTotal],
      vendedorId: [rp.vendedorId],
      vendedorUUID: [rp.vendedorUUID],
      fatCondPgP: [rp.fatCondPgP],
      uuid: [rp.uuid],
      portadorId: [rp.portadorId],
      tipoCobranca: [rp.tipoCobranca],
      searchPortador: [''],
      searchTipoCobranca: [''],
    });

    fbGroup.get('searchPortador')?.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.searching = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.portadorService.getPortadorPageSearch(1, 10, value) :
            this.portadorService.getPortadorPage(1, 10)) : new Observable<PageResult<Portador>>())
          .pipe(
            finalize(() => this.searching = false),
          )
        )
      )
      .subscribe(portadores => {
        this.portadores = portadores.content;
        if (this.condPgP.financPortador !== undefined && this.condPgP.financPortador !== null) {
          if (this.portadores.map(n => n.id).includes(this.condPgP.financPortador.id)) {
            const financPortador = this.portadores.find(n => n.id === this.condPgP.financPortador.id) ?? this.condPgP.financPortador;
            if (financPortador !== null && financPortador !== undefined) {
              this.itemForm.controls['financPortador'].setValue(financPortador);
            }
          } else {
            this.portadores.push(this.condPgP.financPortador);
          }
        }
      });

    /**
     * Search Tipo Cobranca
     */

    // fbGroup.get('searchTipoCobranca').valueChanges
    // .pipe(
    //   debounceTime(500),
    //   tap(() => this.searching = true),
    //   switchMap(value => ((typeof (value) === 'string') ?
    //     (value !== undefined && value !== '' ? this.tipoCobrancaService.getTipoCobrancaPageSearch(1, 10, value) :
    //       this.tipoCobrancaService.getTipoCobrancaPage(1, 10)) : new Observable<PageResult<TipoCobranca>>())
    //     .pipe(
    //       finalize(() => this.searching = false),
    //     )
    //   )
    // )
    // .subscribe(tipos => {
    //   this.tipoCobrancas = tipos.content;
    //   if (this.condPgP.financTipoCobranca !== undefined && this.condPgP.financTipoCobranca !== null) {
    //     if (this.tipoCobrancas.map(n => n.id).includes(this.condPgP.financTipoCobranca.id)) {
    //       const financTipoCobranca = this.tipoCobrancas.find(n => n.id === this.condPgP.financTipoCobranca.id) ?? this.condPgP.financTipoCobranca;
    //       if (financTipoCobranca !== null && financTipoCobranca !== undefined) {
    //         this.itemForm.controls['financTipoCobranca'].setValue(financTipoCobranca);
    //       }
    //     } else {
    //       this.tipoCobrancas.push(this.condPgP.financTipoCobranca);
    //     }
    //   }
    // });



     fbGroup.get('searchTipoCobranca')?.valueChanges
     .pipe(
       filter(search => !!search),
       tap(() => this.searching = true),
       takeUntil(this._onDestroy),
       debounceTime(300),
       map(search => {
         if (!this.tipoCobrancas) {
           return [];
         }
         return this.tipoCobrancaService.getTipoCobrancaPageSearch(1, 10, search+'').subscribe(tipos => {
           this.tipoCobrancas = tipos.content;
           this.filteredTipoCobrancas.next(tipos.content);
         });
       }),
       delay(200),
       takeUntil(this._onDestroy)
     )
     .subscribe(result => {
       this.searching = false;
       if (this.condPgP.financTipoCobranca !== undefined && this.condPgP.financTipoCobranca !== null) {
         if (this.tipoCobrancas.map(n => n.id).includes(this.condPgP.financTipoCobranca.id)) {
           const financTipoCobranca = this.tipoCobrancas.find(n => n.id === this.condPgP.financTipoCobranca.id) ?? this.condPgP.financTipoCobranca;
           if (financTipoCobranca !== null && financTipoCobranca !== undefined) {
             this.itemForm.controls['financTipoCobranca'].setValue(financTipoCobranca);
           }
         } else {
          this.tipoCobrancas.push(this.condPgP.financTipoCobranca);
          this.filteredTipoCobrancas.next(this.tipoCobrancas.slice());
         }

       }
     },
       error => {
         this.searching = false;
         this.confirmService.confirm(
           {
             message: `A T E N Ç Ã O !  ERRO PESQUISANDO TIPO DE COBRANÇA ... ${error}`,
             error: true
           });
       });


    return fbGroup;
  }

  get parcelasFormArray(): FormArray {
    return this.doctoCForm.get('financRps') as FormArray;
  }


  editParcela(row: any) {
    console.log('editDoctoI', row);
    let title = `PARCELA: [  ${row?.docto} ]`;
    let dialogRef: MatDialogRef<any> = this.dialog.open(FinancRpPopupComponent, {
      width: this.layout.isMobile ? '100%' : '98%',
      disableClose: true,
      data: { title: title, payload: row }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        this.reloadParcelas(res);
        if (!res) {

          return;
        }
      })
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  close() {
    this.dialogRef.close();
    // this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
    //   .subscribe(res => {
    //     if (res) {
    //       this.dialogRef.close();
    //     }
    //   });
  }

}


